import { Component } from '@angular/core';
import { SESSION_STORAGE_KEYS } from '../../constants';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css'
})
export class ErrorComponent {

  errorMessage: string = "You are not authorized to view this page. Please login in via the correct link";

  ngOnInit(): void {
    if (sessionStorage.getItem(SESSION_STORAGE_KEYS.SAML_ERROR)) {
      this.errorMessage = "Not authorized. You dont have the required permissions. Check if you have access to crp-admin-content.";
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.SAML_ERROR);
    }
  }
}
